<script setup lang="ts">
import BasicLayout from "../layouts/BasicLayout.vue";
import PopupLauncherContent from "./PopupLauncherContent.vue";
</script>

<template>
  <BasicLayout>
    <PopupLauncherContent></PopupLauncherContent>
  </BasicLayout>
</template>

<style scoped>

</style>
